import { BrowserRouter } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import logo from "../Assets/Images/Ruby-Mine.png";
// import Search from "./Search";

const Header = () => {
  // const preventDefault = (e) => {
  //   e.preventDefault();
  // };
  return (
    <BrowserRouter>
      <header className="header-container">
        <div className="header-image">
          <img className="header-logo" src={logo} alt="logo" />
          {/* <Search /> */}
        </div>
        <nav className="header-nav">
          <ul className="nav-links">
            <li className="nav-item">
              <HashLink
                to="#hero"
                smooth
                className="nav-link nav-link--home"
                // onClick={preventDefault}
              >
                Home
              </HashLink>
            </li>
            <li className="nav-item">
              <HashLink
                to="#carousel"
                smooth
                className="nav-link nav-link--about"
                // onClick={preventDefault}
              >
                About
              </HashLink>
            </li>
            <li className="nav-item">
              <HashLink
                to="#more-features"
                smooth
                className="nav-link nav-link--services"
                // onClick={preventDefault}
              >
                Services
              </HashLink>
            </li>
            <li className="nav-item">
              <HashLink
                to="#footer"
                smooth
                className="nav-link nav-link--settings"
                // onClick={preventDefault}
              >
                Settings
              </HashLink>
            </li>
          </ul>
        </nav>
      </header>
    </BrowserRouter>
  );
};

export default Header;
